import React from 'react'
import type { FC } from 'react'
interface Props {
  className?: string;
  color?: string;
  size?: number | string;
  rotateOnRtl?: boolean;
}
export const IconWindsurfing: FC<Props> = ({
  color = 'currentColor',
  size = 24,
  className,
  rotateOnRtl = false,
  ...rest
}) => {
  const props = {
    width: size,
    height: size,
    fill: color,
    // stroke: color,
    className,
    viewBox: '0 0 24 24',
    ['data-rotateonrtl']: false,
    ...rest,
  }
  return /*#__PURE__*/ React.createElement(
    'svg',
    Object.assign(
      {
        xmlns: 'http://www.w3.org/2000/svg',
        width: 24,
        height: 24,
        viewBox: '0 0 24 24',
      },
      props
    ),
    /*#__PURE__*/ React.createElement('path', {
      d: 'M12 16c-.2 0-.4 0-.6-.1-.2-.2-.3-.4-.4-.7l-2-12c0-.3 0-.6.2-.8.2-.2.4-.4.7-.4l.04-.002c.321-.017 2.414-.127 4.86 1.002 2.4 1.2 5.6 3.8 7.2 9.8 0 .2 0 .5-.2.7-.1.3-.3.4-.6.5l-9 2H12zm.8-2.2l6.9-1.5c-2.2-6.8-6.5-8.1-8.5-8.3l1.6 9.8zm2.5 5.5c.5-.6 1.3-1.3 2.7-1.3 1.851 0 3.236 1.71 3.675 2.252.06.072.101.124.125.148.4.5.3 1.1-.2 1.4-.2.1-.4.2-.6.2-.3 0-.6-.1-.8-.4-.4-.5-1.4-1.6-2.2-1.6-.6 0-.8.2-1.3.7-.5.6-1.3 1.3-2.7 1.3-1.4 0-2.2-.7-2.7-1.3-.5-.5-.7-.7-1.3-.7-.6 0-.8.2-1.3.7-.5.6-1.3 1.3-2.7 1.3-1.851 0-3.236-1.71-3.675-2.252-.06-.073-.101-.124-.125-.148-.4-.5-.3-1.1.2-1.4.5-.4 1.1-.3 1.4.2.4.5 1.4 1.6 2.2 1.6.6 0 .8-.2 1.3-.7.5-.6 1.3-1.3 2.7-1.3 1.4 0 2.2.8 2.7 1.3s.7.7 1.3.7c.6 0 .8-.2 1.3-.7zM4 8c-.3 0-.6.2-.8.4-.2.3-.2.6-.2.9l2 7c.2.4.6.7 1 .7h.3c.5-.2.8-.7.7-1.2L5.3 10H7c.6 0 1-.4 1-1s-.4-1-1-1H4zm3-4a2 2 0 11-4 0 2 2 0 014 0z',
      fillRule: 'evenodd',
      clipRule: 'evenodd',
    })
  )
}
